import {useCustomerInsights} from '../../../hooks/useCustomerInsights';
import {CustomerInsightsPopover} from './CustomerInsightsPopover';

interface CustomerInsightsOpenContentProps {
  customerId: string;
  id: string;
  onClose: VoidFunction;
}

export function CustomerInsightsOpenContent(props: CustomerInsightsOpenContentProps) {
  const viewModel = useCustomerInsights({customerId: props.customerId, enabled: true});

  return <CustomerInsightsPopover id={props.id} viewModel={viewModel} onClose={props.onClose} />;
}
